export default {
    set_recordRewardsItem: (state, payload)=>{
        state.authDonor = payload;
    },
    set_recordRewardsSettings: (state, payload)=>{
        if(typeof payload.companyName !== 'undefined') state.rewardsSettings.companyName = payload.companyName
        if(typeof payload.voucherStyle !== 'undefined') state.rewardsSettings.voucherStyle = payload.voucherStyle
        if(typeof payload.currencyCode !== 'undefined') state.rewardsSettings.currencyCode = payload.currencyCode
        if(typeof payload.currencySymbol !== 'undefined') state.rewardsSettings.currencySymbol = payload.currencySymbol
        if(typeof payload.currencyPosition !== 'undefined') state.rewardsSettings.currencyPosition = payload.currencyPosition
        if(typeof payload.maximumVoucherValue !== 'undefined') state.rewardsSettings.maximumVoucherValue = payload.maximumVoucherValue
        if(typeof payload.rewardExpiryType !== 'undefined') state.rewardsSettings.rewardExpiryType = payload.rewardExpiryType
        if(typeof payload.rewardExpiryValue !== 'undefined') state.rewardsSettings.rewardExpiryValue = payload.rewardExpiryValue
        if(typeof payload.expiryDateFormat !== 'undefined') state.rewardsSettings.expiryDateFormat = payload.expiryDateFormat
        if(typeof payload.termsAndCondition !== 'undefined') state.rewardsSettings.termsAndCondition = payload.termsAndCondition
        if(typeof payload.expiryDateFormat !== 'undefined') state.rewardsSettings.expiryDateFormat = payload.expiryDateFormat
        if(typeof payload.rewardTermsNote !== 'undefined') state.rewardsSettings.rewardTermsNote = payload.rewardTermsNote
        if(typeof payload.postShipping !== 'undefined') state.rewardsSettings.postShipping = payload.postShipping
        if(typeof payload.shippingMethodForPost !== 'undefined') state.rewardsSettings.shippingMethodForPost = payload.shippingMethodForPost
        if(typeof payload.successfulPageMessage !== 'undefined') state.rewardsSettings.successfulPageMessage = payload.successfulPageMessage
        if(typeof payload.orderCancellationMessage !== 'undefined') state.rewardsSettings.orderCancellationMessage = payload.orderCancellationMessage
        if(typeof payload.senderName !== 'undefined') state.rewardsSettings.senderName = payload.senderName
        if(typeof payload.senderEmail !== 'undefined') state.rewardsSettings.senderEmail = payload.senderEmail
        if(typeof payload.buyerEmail !== 'undefined') state.rewardsSettings.buyerEmail = payload.buyerEmail
        if(typeof payload.adminEmail !== 'undefined') state.rewardsSettings.adminEmail = payload.adminEmail
        if(typeof payload.description !== 'undefined') state.rewardsSettings.description = payload.description
    },
    set_recordRewords: (state, payload)=>{
        state.rewards = payload
    },
    set_showPage: (state, payload)=>{
        if(typeof payload.triggerRequestActivationCode !== 'undefined') state.showPage.triggerRequestActivationCode = payload.triggerRequestActivationCode
        if(typeof payload.triggerEnterActivationCode !== 'undefined') state.showPage.triggerEnterActivationCode = payload.triggerEnterActivationCode

    },
    set_recordItemRewards: (state, payload)=>{
        state.selectedRewards = payload
    },
    set_order: (state, payload)=>{
        if(typeof payload.donorFirstName !== 'undefined') state.order.donorFirstName = payload.donorFirstName
        if(typeof payload.donorLastName !== 'undefined') state.order.donorLastName = payload.donorLastName
        if(typeof payload.personalMessage !== 'undefined') state.order.personalMessage = payload.personalMessage
        if(typeof payload.recipientEmail !== 'undefined') state.order.recipientEmail = payload.recipientEmail
    },
}
